import './LanguagePicker.scss';
import React from 'react'
import { getLocale } from 'Store/User/selectors';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { IStore } from 'Store/.';
import { Dispatch, bindActionCreators } from 'redux';
import { setLocale } from 'Store/User/actions';

interface IPropsInternal {
  locale: string;
  setLocale: (locale: string) => void;
}

const LanguagePicker: React.SFC<IPropsInternal> = ({ locale, setLocale }) => {
  return (
    <div className='language-container'>
      <img src='/gb.svg' alt='english language' className={ locale === 'en-GB' ? 'flag-active' : 'flag' } onClick={() => setLocale('en-GB')}/>
      <img src='/se.svg' alt='swedish language' className={ locale === 'sv-SE' ? 'flag-active' : 'flag' } onClick={() => setLocale('sv-SE')}/>
    </div>
  )
}

const mapStateToProps = (state: IStore) => {
  return {
    locale: getLocale(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    setLocale,
  }, dispatch);
};

export default compose<{}, {}>(
  connect(mapStateToProps, mapDispatchToProps),
)(LanguagePicker);


// WEBPACK FOOTER //
// ./src/components/Shared/LanguagePicker/LanguagePicker.tsx